import { UsStateOrTerritoryModel, EducationLevelModel } from './FavoritesService';
import { BuildType } from './ApiService';

export const stateAndEducationApiEndpoints = (build: BuildType) => ({
    getAllStatesAndTerritories: build.query<UsStateOrTerritoryModel[], void>({
        query: () => 'us-state',
    }),
    getEducationLevels: build.query<EducationLevelModel[], void>({
        query: () => 'education-level',
    }),
});
